module.exports = __webpack_public_path__ + "img/type4.14bf9b3d.png";